import React from 'react'
import type { ImageType } from '../../templates/Generic'
import { GatedContentForm } from './GatedContentForm'
import { WhitePaper } from './Whitepaper'
import { Dialog, DialogContent, DialogTrigger } from '../ui/dialog'
import { Button } from '../Button'

export interface GatedContentProps {
  formid: string
  whitepaperTitle: string
  whitepaperContent?: {
    id: string
    content: string
  }[]
  gatedContentUrl: string
  image: ImageType
  whitepaper: boolean
}

export const GatedContentInterstitial = ({
  data,
}: {
  data: GatedContentProps
}) => {
  return (
    <>
      {/* Desktop Layout */}
      <div className="mx-auto my-auto hidden h-full max-w-[960px] flex-col items-center justify-center gap-4 md:flex md:flex-row min-[1100px]:gap-8">
        <WhitePaper data={data} />
        <GatedContentForm data={data} />
      </div>

      {/* Mobile Layout */}
      <div className="flex md:hidden">
        <WhitePaper data={data} />
        <div className="fixed bottom-0 left-0 right-0 z-50 rounded-t-md border-t border-gray-300 bg-white p-4 shadow">
          <Dialog>
            <DialogTrigger asChild>
              <Button className="w-full" btnType="light">
                Access the Whitepaper
              </Button>
            </DialogTrigger>
            <DialogContent className="max-w-[95vw] rounded-md border-gray-300 px-6 py-7">
              <GatedContentForm data={data} />
            </DialogContent>
          </Dialog>
        </div>
      </div>
    </>
  )
}
